import RiskController from './index';

export default { path: '/home/trade/risk/controller', component: RiskController };